import Vue from 'vue'
import { ActionTree, GetterTree, MutationTree } from "vuex"

import { extractResourceIds, filterId, getResource, setIncludedResources } from "~/utils/store"
import { RootState } from "~/store/store.types"

import { PromotionsState, PromotionResource, PromotionsFilter, Promotion } from "./promotion.types"
import { RequestParameters } from "~/utils/SohoApi/SohoApi"
import { SohoModel } from "~/constants/SohoModel"

interface PromotionsMutation {
  params: RequestParameters<Promotion, PromotionsFilter>
  data: PromotionResource[]
}

export const state = ():PromotionsState => ({
  data: {},
  filters: {}
})

export const getters: GetterTree<PromotionsState, RootState> = {
  resourceById (state, _, __, rootGetters) {
    return (id: string, included: string | string[] = []) =>
      getResource<PromotionResource>(state, id, rootGetters, included)
  }
}

export const mutations: MutationTree<PromotionsState> = {
  SET_PROMOTION (state, promotion: PromotionResource) {
    const { id } = promotion

    Vue.set(state.data, id, promotion)
  },

  SET_PROMOTIONS (state, { params, data }: PromotionsMutation) {
    if (data && data.length <= 0) {
      return
    }

    data.forEach(resource => Vue.set(state.data, resource.id, resource))

    const id = filterId(params)

    Vue.set(state.filters, id, extractResourceIds(data))
  }
}

export const actions: ActionTree<PromotionsState, RootState> = {
  async fetchPromotions ({ commit }, params: RequestParameters<Promotion, PromotionsFilter> = {}) {
    const { data, included } = await this.$sohoApi.get<PromotionResource>(SohoModel.Promotion, params)

    // Optionally set the included resources
    if (included) {
      setIncludedResources(included, commit)
    }

    if (data) {
      commit("SET_PROMOTIONS", { params, data })
    }
  }
}
